import PatientManager from "@/views/patient/PatientManager"
import AddPatient from "@/views/patient/AddPatient"
import PatientDetail from "@/views/patient/PatientDetail"
// import Patient from "@/views/patient/PatientDetail"
import Patient from "@/views/patient/Patient"
export const patientmanager = {
    path: '/patientmanager',
    name: 'PatientManager',
    component: PatientManager
  }
  export const addpatient = {
    path: '/addpatient',
    name: 'AddPatient',
    component: AddPatient
  }
  export const patientdetail = {
    path: '/patientdetail',
    name: 'PatientDetail',
    component: PatientDetail
  }
  //新加
  export const patient = {
    path: '/patient',
    name: 'Patient',
    component: Patient
  }


// WEBPACK FOOTER //
// ./src/router/index/patient/index.js